import React, { useState, useEffect, forwardRef } from 'react';

//komponen
import { styled } from '@mui/material/styles';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import Badge from '@mui/material/Badge';
import Typography from '@mui/material/Typography';
import Fab from '@mui/material/Fab';
import LoadingButton from '@mui/lab/LoadingButton';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

//gambar
import AddOutlined from '@mui/icons-material/AddOutlined';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import SaveOutlined from '@mui/icons-material/SaveOutlined';
import CloseOutlined from '@mui/icons-material/CloseOutlined';
import SearchOutlined from '@mui/icons-material/SearchOutlined';
import DeleteIcon from '@mui/icons-material/Delete';

const Input = styled('input')({
    display: 'none',
});

function Produk(props, ref) {
    //state
    const [proses, setProses] = useState(false);
    const [tampil_notif, setTampilNotif] = useState(false);
    const [jenis_notif, setJenisNotif] = useState("success");
    const [isi_notif, setIsiNotif] = useState("");
    const [tampil_dialog, setTampilDialog] = useState(false);
    const [data_jenis, setDataJenis] = useState([]);
    const [sumber_produk, setSumberProduk] = useState([]);
    const [data_produk, setDataProduk] = useState([]);
    const [id_produk, setIdProduk] = useState("");
    const [id_jenis, setIdJenis] = useState("");
    const [nama, setNama] = useState("");
    const [tujuan, setTujuan] = useState("D");
    const [hpp, setHpp] = useState(0);
    const [harga, setHarga] = useState(0);
    const [diskon_persen, setDiskonPersen] = useState(0);
    const [diskon_nominal, setDiskonNominal] = useState(0);
    const [status, setStatus] = useState(false);
    const [label_status, setLabelStatus] = useState("Nonaktif");
    const [tampung_foto, setTampungFoto] = useState(null);
    const [foto, setFoto] = useState(null);
    const [jenis_file, setJenisFile] = useState("");
    const [nama_foto, setNamaFoto] = useState("");
    const [tampil_dialog_hapus, setTampilDialogHapus] = useState(false);

    //fungsi
    useEffect(() => {
        fetch(props.aplikasi + '/produk/tampil_jenis_produk.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        status: ""
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setDataJenis(data.data);
                }
                else {
                    setDataJenis([]);
                }
            })
            .catch(error => {
                setDataJenis([]);
            }
            );

        fetch(props.aplikasi + '/produk/tampil_produk.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        status: ""
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setSumberProduk(data.data);
                    setDataProduk(data.data);
                }
                else {
                    setSumberProduk([]);
                    setDataProduk([]);
                }
            })
            .catch(error => {
                setSumberProduk([]);
                setDataProduk([]);
            }
            );
    }, [props.aplikasi]);

    const format_rupiah = (angka) => {
        return (
            angka
                .toFixed(0)
                .replace(".", ",")
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
        )
    }

    const tutup_notif = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setTampilNotif(false);
    };

    const tampil_produk = () => {
        fetch(props.aplikasi + '/produk/tampil_produk.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        status: ""
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setSumberProduk(data.data);
                    setDataProduk(data.data);
                }
                else {
                    setSumberProduk([]);
                    setDataProduk([]);
                }
            })
            .catch(error => {
                setSumberProduk([]);
                setDataProduk([]);
            }
            );
    }

    const cari = (event) => {
        var cari = (event.target.value).toLowerCase();
        var awal = 1;
        var akhir = sumber_produk.length;

        var posisi = 0;
        var tampung = [];
        while (awal <= akhir) {
            var hasil = ((sumber_produk[awal - 1]["nama"]).toLowerCase()).indexOf(cari);
            if (hasil === -1) {
                hasil = ((sumber_produk[awal - 1]["nama"]).toLowerCase()).indexOf(cari);
            }

            if (hasil !== -1) {
                tampung[posisi] = sumber_produk[awal - 1];
                posisi++;
            }
            awal++;
        }

        setDataProduk(tampung);
    }

    const bersih_input_produk = () => {
        setIdProduk("");
        setIdJenis("");
        setNama("");
        setTujuan("D");
        setHpp(0);
        setHarga(0);
        setDiskonPersen(0);
        setDiskonNominal(0);
        setStatus(false);
        setLabelStatus("Nonaktif");
        setTampungFoto(null);
        setFoto(null);
        setJenisFile("");
        setNamaFoto("");
    }

    const ubah_hpp = (event) => {
        const re = /^[0-9\b]+$/;
        if (re.test(event.target.value) === false && event.target.value !== "") {
            return;
        }
        setHpp(event.target.value);
    }

    const perbaiki_hpp = (event) => {
        if (event.target.value.trim() === "") {
            setHpp(0);
        }
    }

    const ubah_harga = (event) => {
        const re = /^[0-9\b]+$/;
        if (re.test(event.target.value) === false && event.target.value !== "") {
            return;
        }
        setHarga(event.target.value);
    }

    const perbaiki_harga = (event) => {
        if (event.target.value.trim() === "") {
            setHarga(0);
        }
    }

    const ubah_diskon_persen = (event) => {
        const re = /^[+-]?\d*(?:[.]\d*)?$/;
        if (re.test(event.target.value) === false && event.target.value !== "") {
            return;
        }

        setDiskonPersen(event.target.value);
        setDiskonNominal(parseFloat((event.target.value / 100) * parseFloat(harga)).toFixed(2));
    }

    const perbaiki_diskon_persen = (event) => {
        if (event.target.value.trim() === "") {
            setDiskonPersen(0);
        }
    }

    const ubah_diskon_nominal = (event) => {
        const re = /^[+-]?\d*(?:[.]\d*)?$/;
        if (re.test(event.target.value) === false && event.target.value !== "") {
            return;
        }

        setDiskonNominal(event.target.value);
        setDiskonPersen(parseFloat((event.target.value / parseFloat(harga)) * 100).toFixed(2));
    }

    const perbaiki_diskon_nominal = (event) => {
        if (event.target.value.trim() === "") {
            setDiskonNominal(0);
        }
    }

    const simpan = () => {
        if (id_jenis.trim() === "") {
            setJenisNotif("warning");
            setIsiNotif("Jenis produk wajib diisi");
            setTampilNotif(true);
            document.getElementById("id_jenis").focus();
            return;
        }

        if (nama.trim() === "") {
            setJenisNotif("warning");
            setIsiNotif("Nama produk wajib diisi");
            setTampilNotif(true);
            document.getElementById("nama").focus();
            return;
        }

        if (hpp.trim() === "") {
            setJenisNotif("warning");
            setIsiNotif("Harga pokok penjualan wajib diisi");
            setTampilNotif(true);
            document.getElementById("hpp").focus();
            return;
        }

        if (harga.trim() === "") {
            setJenisNotif("warning");
            setIsiNotif("Harga jual wajib diisi");
            setTampilNotif(true);
            document.getElementById("harga").focus();
            return;
        }

        setProses(true);
        if (id_produk === "") {
            fetch(props.aplikasi + '/produk/simpan_produk.php',
                {
                    method: 'POST',
                    body: JSON.stringify
                        ({
                            permintaan: "simpan",
                            id_produk: "",
                            id_jenis: id_jenis,
                            nama: nama,
                            tujuan: tujuan,
                            hpp: hpp,
                            harga: harga,
                            diskon_persen: diskon_persen,
                            diskon_nominal: diskon_nominal,
                            status: status,
                            foto: foto,
                            jenis_file: jenis_file
                        }),
                    headers:
                    {
                        "Content-type": "application/json; charset=UTF-8"
                    }
                })
                .then(response => response.json())
                .then(data => {
                    if (data.kode === 1) {
                        bersih_input_produk();
                        tampil_produk();
                        setJenisNotif("success");
                        setIsiNotif(data.pesan);
                        setTampilNotif(true);
                        document.getElementById("id_jenis").focus();
                        setProses(false);
                    }
                    else {
                        tampil_produk();
                        setJenisNotif("warning");
                        setIsiNotif(data.pesan);
                        setTampilNotif(true);
                        document.getElementById("id_jenis").focus();
                        setProses(false);
                    }
                })
                .catch(error => {
                    tampil_produk();
                    setJenisNotif("error");
                    setIsiNotif("Terjadi kesalahan");
                    setTampilNotif(true);
                    document.getElementById("id_jenis").focus();
                    setProses(false);
                }
                );
        }
        else {
            fetch(props.aplikasi + '/produk/simpan_produk.php',
                {
                    method: 'POST',
                    body: JSON.stringify
                        ({
                            permintaan: "perbarui",
                            id_produk: id_produk,
                            id_jenis: id_jenis,
                            nama: nama,
                            tujuan: tujuan,
                            hpp: hpp,
                            harga: harga,
                            diskon_persen: diskon_persen,
                            diskon_nominal: diskon_nominal,
                            status: status,
                            foto: foto,
                            jenis_file: jenis_file
                        }),
                    headers:
                    {
                        "Content-type": "application/json; charset=UTF-8"
                    }
                })
                .then(response => response.json())
                .then(data => {
                    if (data.kode === 1) {
                        tampil_produk();
                        setJenisNotif("success");
                        setIsiNotif(data.pesan);
                        setTampilNotif(true);
                        document.getElementById("nama").focus();
                        setProses(false);
                    }
                    else {
                        tampil_produk();
                        setJenisNotif("warning");
                        setIsiNotif(data.pesan);
                        setTampilNotif(true);
                        document.getElementById("nama").focus();
                        setProses(false);
                    }
                })
                .catch(error => {
                    tampil_produk();
                    setJenisNotif("error");
                    setIsiNotif("Terjadi kesalahan");
                    setTampilNotif(true);
                    document.getElementById("nama").focus();
                    setProses(false);
                }
                );
        }
    }

    const hapus = () => {
        setProses(true);
        fetch(props.aplikasi + '/produk/hapus_produk.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        id_produk: id_produk
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    bersih_input_produk();
                    tampil_produk();
                    setJenisNotif("success");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                    document.getElementById("nama").focus();
                    setProses(false);
                }
                else {
                    tampil_produk();
                    setJenisNotif("warning");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                    document.getElementById("nama").focus();
                    setProses(false);
                }
            })
            .catch(error => {
                tampil_produk();
                setJenisNotif("error");
                setIsiNotif("Terjadi kesalahan");
                setTampilNotif(true);
                document.getElementById("nama").focus();
                setProses(false);
            }
            );
    }

    return (
        <div>
            <Snackbar
                open={tampil_notif}
                autoHideDuration={3000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={tutup_notif}
            >
                <Alert
                    severity={jenis_notif}
                    variant="filled"
                    onClose={tutup_notif}
                    sx={{ width: '100%' }}
                >
                    {isi_notif}
                </Alert>
            </Snackbar>

            <Box
                sx={{
                    backgroundColor: "#eff0f0",
                    width: "100%",
                    height: "100%"
                }}
            >
                <Fab
                    color="primary"
                    sx={{
                        background: "#37ce9b",
                        border: "#37ce9b",
                        margin: 0,
                        top: "auto",
                        right: 20,
                        bottom: 20,
                        left: "auto",
                        position: "fixed",
                        zIndex: "99"
                    }}
                    onClick={() => {
                        bersih_input_produk();
                        setTampilDialog(true);
                    }}
                >
                    <AddOutlined />
                </Fab>

                <Card
                    sx={{ padding: "10px" }}
                >
                    <TextField
                        id="input-with-icon-textfield"
                        label="Cari berdasarkan nama produk"
                        variant="outlined"
                        size="small"
                        fullWidth
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <SearchOutlined />
                                </InputAdornment>
                            ),
                        }}
                        onChange={cari}
                    />
                </Card>

                <Grid container sx={{ padding: "10px" }}>
                    {data_jenis.map((data_jenis) => {
                        return (
                            <Grid
                                item xs={12}
                            >
                                <Grid
                                    item
                                >
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            padding: "5px",
                                            marginBottom: "5px",
                                            backgroundColor: "#baa8e6",
                                            color: "white"
                                        }}
                                    >
                                        {data_jenis.nama}
                                    </Typography>
                                </Grid>

                                <Grid
                                    container spacing={1}
                                >
                                    {data_produk
                                        .filter(tampung_produk => data_jenis.id_jenis === tampung_produk.id_jenis)
                                        .map((tampung_produk) => {
                                            return (
                                                <Grid
                                                    item xs={6} md={3} lg={2}
                                                    key={tampung_produk.id_produk}
                                                    onClick={() => {
                                                        bersih_input_produk();
                                                        setIdProduk(tampung_produk.id_produk);
                                                        setIdJenis(tampung_produk.id_jenis);
                                                        setNama(tampung_produk.nama);
                                                        setTujuan(tampung_produk.tujuan);
                                                        setHpp(tampung_produk.hpp);
                                                        setHarga(tampung_produk.harga);
                                                        setDiskonPersen(tampung_produk.diskon_persen);
                                                        setDiskonNominal(tampung_produk.diskon_nominal);
                                                        if (tampung_produk.status === "1") {
                                                            setStatus(true);
                                                            setLabelStatus("Aktif");
                                                        }
                                                        else {
                                                            setStatus(false);
                                                            setLabelStatus("Nonaktif");
                                                        }
                                                        setNamaFoto(tampung_produk.foto);
                                                        setTampilDialog(true);
                                                    }}
                                                >
                                                    <Card>
                                                        <ImageListItem>
                                                            <CardMedia
                                                                component="img"
                                                                src={props.file + "/Foto/Produk/" + tampung_produk.foto}
                                                                sx={{
                                                                    backgroundColor: "gray",
                                                                    width: "400px",
                                                                    height: "200px"
                                                                }}
                                                            />
                                                            <ImageListItemBar
                                                                title={tampung_produk.nama}
                                                                subtitle={"Rp. " + format_rupiah(parseFloat(tampung_produk.harga - tampung_produk.diskon_nominal))}
                                                            />
                                                        </ImageListItem>
                                                    </Card>
                                                </Grid>
                                            );
                                        })}
                                </Grid>
                            </Grid>
                        )
                    })}
                </Grid>
            </Box>

            <Dialog
                open={tampil_dialog}
                onClose={() => setTampilDialog(false)}
            >
                <DialogTitle>Input Data Produk</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        <center>
                            <Badge
                                overlap="circular"
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                badgeContent={
                                    <label htmlFor="icon-button-file">
                                        <Input accept="image/*" id="icon-button-file" type="file"
                                            onChange={(e) => {
                                                setFoto(e.target.files[0]);
                                                setTampungFoto(e.target.files[0]);
                                                setJenisFile(e.target.files[0].name.split(".").pop());
                                                let reader = new FileReader();
                                                reader.readAsDataURL(e.target.files[0]);
                                                reader.onload = () => {
                                                    setFoto(reader.result);
                                                }
                                            }}
                                        />
                                        <Fab
                                            size="small"
                                            color="primary"
                                            component="span"
                                        >
                                            <PhotoCamera />
                                        </Fab>
                                    </label>
                                }
                            >
                                <CardMedia
                                    component="img"
                                    src={tampung_foto !== null ? URL.createObjectURL(tampung_foto) : props.file + "/Foto/Produk/" + nama_foto}
                                    sx={{
                                        backgroundColor: "gray",
                                        width: "250px",
                                        height: "200px"
                                    }}
                                />
                            </Badge>
                        </center>
                        <br />
                        <Grid container item spacing={1}>
                            <Grid container item>
                                <Grid item xs={5} sm={4} md={4}>
                                    <Typography variant="body2">
                                        Jenis
                                    </Typography>
                                </Grid>

                                <Grid item xs={7} sm={8} md={8}>
                                    <FormControl size="small" fullWidth>
                                        <Select
                                            id="id_jenis"
                                            variant="outlined"
                                            fullWidth
                                            value={id_jenis}
                                            onChange={(event) => setIdJenis(event.target.value)}
                                        >
                                            {data_jenis.map((data_jenis) => {
                                                return (
                                                    <MenuItem key={data_jenis.id_jenis} value={data_jenis.id_jenis}>{data_jenis.nama}</MenuItem>
                                                )
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={5} sm={4} md={4}>
                                    <Typography variant="body2">
                                        Nama
                                    </Typography>
                                </Grid>

                                <Grid item xs={7} sm={8} md={8}>
                                    <TextField
                                        id="nama"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        multiline
                                        value={nama}
                                        onChange={(event) => setNama(event.target.value)}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={5} sm={4} md={4}>
                                    <Typography variant="body2">
                                        Tujuan
                                    </Typography>
                                </Grid>

                                <Grid item xs={7} sm={8} md={8}>
                                    <FormControl size="small" fullWidth>
                                        <Select
                                            id="tujuan"
                                            variant="outlined"
                                            fullWidth
                                            value={tujuan}
                                            onChange={(event) => setTujuan(event.target.value)}
                                        >
                                            <MenuItem value="D">Dapur</MenuItem>
                                            <MenuItem value="B">Barista</MenuItem>
                                            <MenuItem value="K">Kasir</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={5} sm={4} md={4}>
                                    <Typography variant="body2">
                                        Harga Pokok Penjualan
                                    </Typography>
                                </Grid>

                                <Grid container item xs={7} sm={8} md={8}>
                                    <Grid item xs={4}>
                                        <TextField
                                            id="hpp"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            multiline
                                            value={hpp}
                                            onChange={(event) => ubah_hpp(event)}
                                            onBlur={(e) => perbaiki_hpp(e)}
                                        />
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Typography variant="h4" align="right" sx={{ color: "red" }}>
                                            Rp. {format_rupiah(parseInt(hpp))}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={5} sm={4} md={4}>
                                    <Typography variant="body2">
                                        Harga Jual
                                    </Typography>
                                </Grid>

                                <Grid container item xs={7} sm={8} md={8}>
                                    <Grid item xs={4}>
                                        <TextField
                                            id="harga"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            multiline
                                            value={harga}
                                            onChange={(event) => ubah_harga(event)}
                                            onBlur={(e) => perbaiki_harga(e)}
                                        />
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Typography variant="h4" align="right" sx={{ color: "red" }}>
                                            Rp. {format_rupiah(parseInt(harga))}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={5} sm={4} md={4}>
                                    <Typography variant="body2">
                                        Diskon
                                    </Typography>
                                </Grid>

                                <Grid container spacing={1} item xs={7} sm={8} md={8}>
                                    <Grid item xs={6}>
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            multiline
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        %
                                                    </InputAdornment>
                                                ),
                                            }}
                                            value={diskon_persen}
                                            onChange={(e) => ubah_diskon_persen(e)}
                                            onBlur={(e) => perbaiki_diskon_persen(e)}
                                        />
                                    </Grid>

                                    <Grid item xs={6}>
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            multiline
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        Rp.
                                                    </InputAdornment>
                                                ),
                                            }}
                                            value={diskon_nominal}
                                            onChange={(e) => ubah_diskon_nominal(e)}
                                            onBlur={(e) => perbaiki_diskon_nominal(e)}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={5} sm={4} md={4}>
                                    <Typography variant="body2">
                                        Status
                                    </Typography>
                                </Grid>

                                <Grid item xs={7} sm={8} md={8}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={status}
                                                onChange={(event) => {
                                                    if (status === false) {
                                                        setStatus(true);
                                                        setLabelStatus("Aktif");
                                                    }
                                                    else {
                                                        setStatus(false);
                                                        setLabelStatus("Nonaktif");
                                                    }
                                                }}
                                            />
                                        }

                                        label={label_status}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <LoadingButton
                        loadingPosition="start"
                        variant="contained"
                        color="primary"
                        startIcon={<SaveOutlined />}
                        sx={{ marginRight: "5px", marginTop: "5px", borderRadius: "5em" }}
                        loading={proses}
                        onClick={() => simpan()}
                    >
                        <Typography variant="body2" noWrap={true}>{id_produk === "" ? "Simpan" : "Perbarui"}</Typography>
                    </LoadingButton>

                    <LoadingButton
                        loadingPosition="start"
                        variant="contained"
                        color="primary"
                        startIcon={<DeleteIcon />}
                        sx={{ marginRight: "5px", marginTop: "5px", borderRadius: "5em", backgroundColor: "red" }}
                        loading={proses}
                        onClick={() => setTampilDialogHapus(true)}
                    >
                        <Typography variant="body2" noWrap={true}>Hapus</Typography>
                    </LoadingButton>

                    <LoadingButton
                        loadingPosition="start"
                        variant="contained"
                        color="primary"
                        startIcon={<CloseOutlined />}
                        sx={{ marginRight: "5px", marginTop: "5px", borderRadius: "5em", backgroundColor: "#555555" }}
                        loading={proses}
                        onClick={() => setTampilDialog(false)}
                    >
                        <Typography variant="body2" noWrap={true}>Tutup</Typography>
                    </LoadingButton>
                </DialogActions>
            </Dialog>

            <Dialog
                open={tampil_dialog_hapus}
                onClose={() => setTampilDialogHapus(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Konfirmasi Hapus Produk
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Apakah anda yakin ingin menghapus data ini?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <LoadingButton
                        loadingPosition="start"
                        loading={proses}
                        onClick={() => setTampilDialogHapus(false)}
                        autoFocus
                    >
                        Tidak
                    </LoadingButton>
                    <LoadingButton
                        loadingPosition="start"
                        loading={proses}
                        onClick={() => {
                            setTampilDialogHapus(false);
                            setTampilDialog(false);
                            hapus();
                        }}
                    >
                        Ya
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default forwardRef(Produk);